export default { sha: 'b6813e2c468f73260274d8dfcd8e57325a945fc4', buildNumber: 'undefined' }
